const EQUIPMENT_REQUEST_STATUS_CHOICES = {
    S: 'Submitted',
    A: 'Approved',
    H: 'Shipped'
}

export function createRequestsList(requests) {
    let list = []

    requests.forEach(request => {

        let listItem = {...request}

        listItem['job'] = request.job.name
        listItem['status'] = EQUIPMENT_REQUEST_STATUS_CHOICES[request.status]

        list.push(listItem)
    })

    return list
}